/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancellation_Deadline_GenericInputs */

const en_cancellation_deadline_generic = /** @type {(inputs: Cancellation_Deadline_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full refund on eligible dates, less the payment provider's fee — pick your dates to see the deadline.`)
};

/**
* | output |
* | --- |
* | "Full refund on eligible dates, less the payment provider's fee — pick your dates to see the deadline." |
*
* @param {Cancellation_Deadline_GenericInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cancellation_deadline_generic = /** @type {((inputs?: Cancellation_Deadline_GenericInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancellation_Deadline_GenericInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cancellation_deadline_generic(inputs)
});